import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import BannersPage from "./pages/Banners/BannersPage"; // Adjust the path if needed
import HomePageOne from "./pages/HomePageOne";
import LandingPageWrapper from "./pages/LandingPage";
import SignInPage from "./pages/General/SignInPage";
import SignUpPage from "./pages/General/SignUpPage";
import BrokersPage from "./pages/Users/BrokersPage";
import DeveloperSalesPage from "./pages/Users/DevelopersSalesPage";
import AddBrokerPage from "./pages/Users/AddBrokerPage";
import AddDeveloperSalesPage from "./pages/Users/AddDeveloperSalesPage";
import ProjectsPage from "./pages/Projects/ProjectsPage";
import AddProjectPage from "./pages/Projects/AddProjectPage";
import UnitsPage from "./pages/Units/UnitsPage";
import AddUnitPage from "./pages/Units/AddUnitPage";
import UnitsProjectsPage from "./pages/Units/UnitsProjectsPage";
import CILsPage from "./pages/CILs/CILsPage";
import EOIsPage from "./pages/EOIs/EOIsPage";
import PaymentPlanPage from "./pages/PaymentPlans/PaymentPlanPage";
import AddPaymentPlanPage from "./pages/PaymentPlans/AddPaymentPlanPage";
import ErrorPage from "./pages/ErrorPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import LocationPage from "./pages/Locations/PaymentPlanPage";
import AddLocationPage from "./pages/Locations/AddLocationPage";
import ViewProfilePage from "./pages/ViewProfilePage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import AddDevPage from "./pages/Devs/AddDevPage";
import DevsPage from "./pages/Devs/DevsPage";
import { ToastContainer } from "react-toastify";
import DeletionRequestPage from "./pages/DeletionRequests/DeletionRequestsPage";
import DeveloperFormPage from "./pages/Devs/DeveloperFormPage";
import ApprovalRequestPage from "./pages/ApprovalRequests/ApprovalRequestsPage";
import SettingsPage from "./pages/Settings/SettingsPage";
import CollectionRequestPage from "./pages/CollectionRequests/CollectionRequestsPage";
import CustomCILsPage from "./pages/CILs/CustomCILsPage";
import BrokerWalletsPage from "./pages/Wallets/BrokerWalletsPage";
import ResaleUnitsPage from "./pages/ResaleUnits/ResaleUnitsPage";
import ResaleInterestsPage from "./pages/ResaleInterests/ResaleInterestsPage";

function App() {
  const [user, setUser] = useState(null);

  // No need to store in state if we always read from localStorage for routes
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const PrivateRoute = ({ children }) => {
    const access_token = localStorage.getItem("access_token");
    return access_token ? children : <Navigate to="/" replace />;
  };

  const PublicRoute = ({ children }) => {
    const access_token = localStorage.getItem("access_token");
    return access_token ? <Navigate to="/dashboard" replace /> : children;
  };

  // Root route shows landing page for guests, redirects to dashboard for authenticated users
  const RootRoute = () => {
    const access_token = localStorage.getItem("access_token");
    return access_token ? <Navigate to="/dashboard" replace /> : <LandingPageWrapper />;
  };

  return (
    <BrowserRouter>
      <ToastContainer />
      <RouteScrollToTop />
      <Routes>
        {/* Root - Landing Page for guests, redirect to dashboard for authenticated */}
        <Route path="/" element={<RootRoute />} />
        
        {/* Dashboard - Protected home for authenticated users */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <HomePageOne />
            </PrivateRoute>
          }
        />
        <Route
          path="/sign-in"
          element={
            <PublicRoute>
              <SignInPage />
            </PublicRoute>
          }
        />
        <Route
          path="/sign-up"
          element={
            <PublicRoute>
              <SignUpPage />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPasswordPage />
            </PublicRoute>
          }
        />
        <Route
          path="/developers-register"
          element={
            <PublicRoute>
              <DeveloperFormPage />
            </PublicRoute>
          }
        />
        <Route
          path="/brokers"
          element={
            <PrivateRoute>
              <BrokersPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/developersales"
          element={
            <PrivateRoute>
              <DeveloperSalesPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/projects"
          element={
            <PrivateRoute>
              <ProjectsPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/add-project"
          element={
            <PrivateRoute>
              <AddProjectPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/devs"
          element={
            <PrivateRoute>
              <DevsPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/add-dev"
          element={
            <PrivateRoute>
              <AddDevPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/units"
          element={
            <PrivateRoute>
              <UnitsProjectsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/units/:projectId"
          element={
            <PrivateRoute>
              <UnitsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-unit"
          element={
            <PrivateRoute>
              <AddUnitPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/cils"
          element={
            <PrivateRoute>
              <CILsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/custom-cils"
          element={
            <PrivateRoute>
              <CustomCILsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/eois"
          element={
            <PrivateRoute>
              <EOIsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/paymentplans"
          element={
            <PrivateRoute>
              <PaymentPlanPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-paymentplan"
          element={
            <PrivateRoute>
              <AddPaymentPlanPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/locations"
          element={
            <PrivateRoute>
              <LocationPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-location"
          element={
            <PrivateRoute>
              <AddLocationPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/deletionRequests"
          element={
            <PrivateRoute>
              <DeletionRequestPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/approvalRequests"
          element={
            <PrivateRoute>
              <ApprovalRequestPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/collectionRequests"
          element={
            <PrivateRoute>
              <CollectionRequestPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/resale-units"
          element={
            <PrivateRoute>
              <ResaleUnitsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/resale-interests"
          element={
            <PrivateRoute>
              <ResaleInterestsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <ViewProfilePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <SettingsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/broker-wallets"
          element={
            <PrivateRoute>
              <BrokerWalletsPage />
            </PrivateRoute>
          }
        />
        <Route path="/banners" element={<BannersPage />} />

        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
